export default "__VITE_ASSET__ClML9ENm__"